import React from "react";
import { Avatar, Typography, Tag, Badge, Tooltip, Button, Space } from "antd";
import { UserOutlined, CrownOutlined } from "@ant-design/icons";
import { COLORS, DirectoryItem } from "../types/types";

const { Text } = Typography;

export const columns = (activeTab: string) => {
  const allColumns: any[] = [
    {
      title: "Profil",
      key: "profile",
      width: 320,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 'bold' }
      }),
      render: (_: any, record: DirectoryItem) => {
        const displayName = record.type === "client"
          ? `${record.prenom || ''} ${record.nom || ''}`.trim()
          : `${record.firstname || ''} ${record.name || ''}`.trim();

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Avatar
              size={44}
              src={record.profile_picture ? `${process.env.REACT_APP_API_BASE}/${record.profile_picture}` : undefined}
              icon={!record.profile_picture ? <UserOutlined /> : undefined}
              style={{
                border: record.is_premium_directory ? `2px solid ${COLORS.secondary}` : "none",
                boxShadow: record.is_premium_directory ? `0 0 0 2px ${COLORS.light}` : "none",
              }}
            />
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                <Text strong>
                  {displayName || "Nom non renseigné"}
                </Text>
                {record.type === "user" && record.is_premium_directory && record.premium_position && (
                  <Badge
                    count={
                      <Tooltip title={`Position #${record.premium_position} dans l'annuaire premium`}>
                        <div style={{
                          backgroundColor: COLORS.secondary,
                          color: "white",
                          padding: "2px 8px",
                          borderRadius: 12,
                          fontSize: 11,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                        }}>
                          <CrownOutlined style={{ fontSize: 10 }} />
                        </div>
                      </Tooltip>
                    }
                    offset={[0, 0]}
                    style={{ backgroundColor: "transparent", boxShadow: "none" }}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Entreprise",
      key: "entreprise",
      width: 250,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 'bold' }
      }),
      render: (_: any, record: DirectoryItem) => {
        const company = record.companyInfo || {};
        const companyName = record.type === "client"
          ? (record as any).raison_sociale
          : record.company;

        return (
          <div>
            {companyName && <Text strong style={{ display: "block" }}>{companyName}</Text>}
            {company.formatJuridique && (
              <Text style={{ fontSize: 11, color: COLORS.textLight, display: "block" }}>
                {company.formatJuridique}
              </Text>
            )}
            {company.siret && (
              <Text style={{ fontSize: 11, color: COLORS.textLight, display: "block" }}>
                SIRET: {company.siret}
              </Text>
            )}
            {(record.code_NAF || company.naf_ape) && (
              <Tag color="purple" style={{ fontSize: 10, marginTop: 2 }}>
                NAF {record.code_NAF || company.naf_ape}
              </Tag>
            )}
          </div>
        );
      },
    },
  ];

  if (activeTab === "Autres") {
    allColumns.push({
      title: "Profession",
      key: "profession",
      dataIndex: "profession",
      width: 220,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 'bold' }
      }),
      render: (profession: string, record: DirectoryItem) => (
        <div>
          <Text>{profession || "Non spécifié"}</Text>
          {record.is_premium_directory && (
            <Tag color={COLORS.secondary} style={{ marginLeft: 8, fontSize: 10 }}>
              <CrownOutlined /> Premium
            </Tag>
          )}
        </div>
      ),
    });
  }

  allColumns.push(
    {
      title: "Contact",
      key: "contact",
      width: 250,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 'bold' }
      }),
      render: (_: any, record: DirectoryItem) => (
        <div>
          {record.email && (
            <a href={`mailto:${record.email}`} style={{ color: COLORS.primary }}>
              {record.email}
            </a>
          )}
          {(record.number || record.telephone) && (
            <Text style={{ fontSize: 12, display: "block", color: COLORS.textLight }}>
              {record.number || record.telephone}
            </Text>
          )}
        </div>
      ),
    },
    {
      title: "Adresse",
      key: "location",
      width: 280,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 600 }
      }),
      render: (_: any, record: DirectoryItem) => (
        <div style={{ padding: '8px 4px' }}>
          {record.adresse && (
            <Text style={{ fontSize: '13px', color: COLORS.text, display: 'block', lineHeight: 1.5 }}>
              {record.adresse}
            </Text>
          )}
          {(record.postal_code || record.code_postal || record.country || record.ville) && (
            <Text style={{ fontSize: '12px', color: COLORS.textLight, display: 'block', marginTop: 4 }}>
              {record.postal_code || record.code_postal} {record.country || record.ville}
            </Text>
          )}
        </div>
      ),
    },  
    {
      title: "",
      key: "actions",
      width: 100,
      onHeaderCell: () => ({
        style: { backgroundColor: COLORS.primary, color: 'white', fontWeight: 'bold' }
      }),
      render: (_: any, record: DirectoryItem) => (
        record.email ? (
          <Button type="link" href={`mailto:${record.email}`} style={{ color: COLORS.textLight, textDecoration: "none" }}>
            Contacter
          </Button>
        ) : null
      ),
    }
  );

  return allColumns;
};